"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../../material/index");

var _dropdownindicator = _interopRequireDefault(require("./dropdownindicator/dropdownindicator"));

var _dropdownitem = _interopRequireDefault(require("./dropdownitem/dropdownitem"));

var _index2 = require("../../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _multiselect_styles = _interopRequireDefault(require("./multiselect_styles"));

var _multiselect_definition = _interopRequireDefault(require("./multiselect_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : DROPDOWN : MULTI SELECT ~~~~~~~~~~ ========== */


var MultiSelectDropDown =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiSelectDropDown, _Component);

  function MultiSelectDropDown(props) {
    var _this;

    _classCallCheck(this, MultiSelectDropDown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelectDropDown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      // ignore clicks on the component itself
      if (_this.node.contains(e.target)) {
        return;
      }

      if (_this.state.active) _this.hideMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "hideMenu", function () {
      return _this.setState({
        active: false,
        searchTerm: '',
        inEditState: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (items) {
      _this.props.onSelect(items);

      _this.filterAvailable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (item) {
      var items = [].concat(_toConsumableArray(_this.props.selectedItems), [item]);

      _this.onSelect(items);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDeselect", function (item) {
      var items = _toConsumableArray(_this.props.selectedItems);

      items.splice(items.indexOf(item), 1);

      _this.onSelect(items);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterClick", function () {
      _this.props.buttonAction(_this.props.selectedItems);

      _this.setState({
        active: false
      });

      _this.filterAvailable = false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleIndicatorClick", function (e) {
      if (_this.props.items.length > 10 && _this.props.searchable !== false) {
        _this.node.querySelector('input').focus();
      }

      _this.setState({
        active: !_this.state.active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (searchTerm) {
      return _this.setState({
        searchTerm: searchTerm
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function () {
      var itemValues = _this.props.items.map(function (item) {
        return item.value;
      });

      _this.setState({
        searchTerm: ''
      });

      _this.onSelect(itemValues);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectNone", function () {
      _this.onSelect([]);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNewItemClick", function () {
      _this.props.onNewItemClick();

      _this.hideMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "isUniqueName", function (newItemName) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.props.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          if (item.name === newItemName) return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "renderItems", function () {
      return _this.props.items.map(function (item, i) {
        return _react.default.createElement(_dropdownitem.default, {
          key: "".concat(i, "-").concat(item.value),
          index: i,
          value: item.value,
          itemName: item.name,
          editable: _this.props.editable,
          inEditState: _this.state.inEditState,
          onItemUpdate: _this.props.onItemUpdate,
          onItemDelete: _this.props.onItemDelete,
          handleSelect: _this.handleSelect,
          handleDeselect: _this.handleDeselect,
          searchTerm: _this.state.searchTerm,
          isUniqueName: _this.isUniqueName,
          itemSelected: _this.props.selectedItems.indexOf(item.value) >= 0
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderControls", function () {
      return _this.props.items.length > 10 && _react.default.createElement("div", {
        className: 'selectors'
      }, _react.default.createElement("div", {
        onClick: _this.handleSelectAll,
        className: "all-items"
      }, " ", _react.default.createElement(_index.Icon, {
        name: "plus-circle"
      }), " Select all"), _react.default.createElement("div", {
        onClick: _this.handleSelectNone,
        className: "all-items"
      }, " ", _react.default.createElement(_index.Icon, {
        name: "times-circle"
      }), " Select none"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearchBar", function () {
      return _this.props.items.length > 10 && _this.props.searchable !== false && _react.default.createElement(_index.SearchBar, {
        value: _this.state.searchTerm,
        onChange: _this.handleSearch
      });
    });

    _this.state = {
      active: false,
      searchTerm: '',
      inEditState: false
    };
    _this.filterAvailable = false;
    return _this;
  }

  _createClass(MultiSelectDropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          name = _this$props.name;
      var active = this.state.active;
      return _react.default.createElement("div", {
        className: "searchabledropdown multiselectdropdown dropdown ".concat(this.props.classes.multiselectdropdown, " ").concat((0, _index2.generateClasses)(this.props), " disabled-").concat(this.props.disabled),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement(_dropdownindicator.default, {
        active: active,
        title: title,
        name: name,
        selected: this.props.selectedItems.length,
        icon: this.props.icon,
        toggleMenu: this.handleIndicatorClick
      }), _react.default.createElement(_index.Group, {
        name: "menuItems active-".concat(this.state.active)
      }, _react.default.createElement(_index.Group, null, this.renderSearchBar(), this.renderControls(), _react.default.createElement("div", {
        className: this.props.items.length > 10 ? "items" : null
      }, this.renderItems())), _react.default.createElement(_index.Group, null, this.props.editable && _react.default.createElement(_index.Link, {
        name: 'managecontrolitem',
        type: 'action',
        variant: 'primary',
        text: "".concat(!this.state.inEditState ? "Manage ".concat(this.props.name) : "Complete managing"),
        icon: this.state.inEditState ? 'arrow-circle-left' : 'edit',
        operation: 'load',
        behavior: 'none',
        iconRight: false,
        handleClick: function handleClick() {
          return _this2.setState({
            inEditState: !_this2.state.inEditState
          });
        },
        color: 'neutral',
        badge: '',
        disabled: this.props.items.length === 0,
        processing: false
      }), this.props.editable && _react.default.createElement(_index.Link, {
        name: 'addcontrolitem',
        type: 'action',
        variant: 'primary',
        text: "New ".concat(this.props.name),
        icon: "plus",
        operation: 'load',
        behavior: 'none',
        iconRight: false,
        handleClick: this.handleNewItemClick,
        color: 'neutral',
        badge: '',
        disabled: false,
        processing: false
      }), this.props.button !== false && _react.default.createElement(_index.Button, {
        handleClick: this.handleFilterClick,
        variant: this.filterAvailable ? "primary" : "disabled",
        name: "filter",
        text: "Filter"
      }))));
    }
  }]);

  return MultiSelectDropDown;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(MultiSelectDropDown, _multiselect_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_multiselect_styles.default)(MultiSelectDropDown);

exports.default = _default;